// extracted by mini-css-extract-plugin
export default {"title":"kKuXKf","rowTitle":"RaIPqr","icons":"LE4lF8","icon":"DdDzW9","row":"iguBq3"};